import React from "react";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function Loader({ isLoading }) {
    if (!isLoading) return null
  return <div className="loader-mask"><FontAwesomeIcon icon={faSpinner} spin={true} size="3x" /></div>;
}

export default Loader